import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Stacked from '../../../../shared/Stacked/stacked.vue';
import EpicExploreNeighbour from '../../../../RifoDesign/EpicExploreNeighbour/epic.explore.neighbour.vue';
import EpicFeatures from '../../../../RifoDesign/EpicFeatures/epic.features.vue';
import EpicNews from '../../../../RifoDesign/EpicNews/epic.news.vue';
import EpicFootnav from '../../../../RifoDesign/EpicFootNav/epic.footnav.vue';
import EpicStandardLayout from '../../../../layout/EpicStandard/epic.standard.layout.vue';
import EpicHomeVideo from '../../../../RifoDesign/EpicHomeVideo/epic.home.video.vue';
import { CommonConfig } from '../../../../configs/config.common';

@Component({
    components: {
        Stacked,
        EpicExploreNeighbour,
        EpicFeatures,
        EpicNews,
        EpicFootnav,
        EpicHomeVideo,
        'layout': EpicStandardLayout,
    }
})
export default class HomeEpic extends Vue {
    public title: string = 'HomeEpic';
    public configs = new CommonConfig();

    @Prop()
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public mounted() {
        document.title = 'RIFO Realty Group';
    }

    public bgBlurStyle() {
        return this.$store.state.home.homeBgBlur ? {
            'filter': 'blur(10px) brightness(1)'
        } : {
                'filter': 'blur(0px) brightness(1)'
            };
    }
}
